import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";

export default function RealEstateInvestmentCyprus() {

    return (
        <main className='main'>
            <IntroSection
                title="Real Estate Investment in Cyprus"
                subtitle="Secure Residency & EU Access Through Property Investment"
                description="Cyprus is one of Europe’s most attractive destinations for real estate investors, entrepreneurs, and families. With its Mediterranean lifestyle, EU membership, and tax-friendly regime, Cyprus provides a clear pathway to permanent residency and long-term relocation through strategic property investment."
                badges={[
                    "Residency by Investment",
                    "EU Market Access",
                    "Property Ownership Rights"
                ]}
                buttonText="Request a Cyprus Real Estate Consultation →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/real-estate/real-estate-investment-cyprus-hero.png')}
                imageAlt="Cyprus Real Estate Investment"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Invest in Cyprus Real Estate?"
                        blocks={[
                            {
                                items: [
                                    { title: "Residency & Citizenship Options", text: "Permanent residency through property investment and eligibility for citizenship after years of residence." },
                                    { title: "Property Market Growth", text: "Strong demand across Nicosia, Limassol, Larnaca, and Paphos." },
                                    { title: "Strategic Location", text: "A key hub connecting Europe, Asia, and the Middle East." },
                                    { title: "Tax Advantages", text: "No inheritance tax, favorable non-dom regime, and 12.5% corporate tax rate." },
                                    { title: "High Living Standards", text: "Modern infrastructure, healthcare, education, and safe environment." },
                                    { title: "Rental Income Potential", text: "Demand for both long-term and holiday rentals." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Residency by Real Estate Investment"
                        blocks={[
                            {
                                head: "Permanent Residency (Category F / Fast-Track)",
                                items: [
                                    { text: "Minimum €300,000 investment in new residential property." },
                                    { text: "Covers main applicant, spouse, and dependent children." },
                                    { text: "Residency approval typically within 2–4 months." }
                                ]
                            },
                            {
                                head: "Citizenship by Naturalization",
                                items: [
                                    { text: "Requires 7 years of legal residence (5 years if married to a Cypriot national)." },
                                    { text: "Investment in real estate supports stronger eligibility." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Property Ownership Rules"
                        blocks={[
                            {
                                items: [
                                    { text: "Non-EU investors may purchase up to two properties (house/apartment + land/office)." },
                                    { text: "Full freehold ownership is available to foreigners." },
                                    { text: "Cyprus’ title deed system ensures secure and transparent ownership." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Best Areas for Real Estate Investment"
                        blocks={[
                            {
                                items: [
                                    { text: "Limassol – financial hub with luxury towers and beachfront projects." },
                                    { text: "Nicosia – capital city with strong local rental demand." },
                                    { text: "Larnaca – affordable coastal living with large marina redevelopment." },
                                    { text: "Paphos – favored by retirees, known for resorts and holiday homes." },
                                    { text: "Ayia Napa & Protaras – tourism-driven markets with high seasonal yields." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Typical Investment Models"
                        services={[
                            { title: "Residential Properties", text: "Villas, apartments, and townhouses across major cities and coastal towns." },
                            { title: "Commercial Real Estate", text: "Investment in offices, retail, and industrial space." },
                            { title: "Holiday Rentals", text: "Strong seasonal demand via Airbnb and resort tourism." },
                            { title: "Mixed-Use Developments", text: "Hotels, resorts, marinas, and integrated lifestyle projects." }
                        ]}
                    />

                    <WhySection
                        title="Advantages of Cyprus Real Estate Investment"
                        blocks={[
                            {
                                items: [
                                    { title: "EU Residency", text: "Secure permanent residency within the European Union." },
                                    { title: "Asset Appreciation", text: "Steady increases in value across prime coastal and urban areas." },
                                    { title: "Family Coverage", text: "Residency benefits extend to spouse and dependent children." },
                                    { title: "Secure Ownership", text: "Strong legal protections supported by title deed guarantees." },
                                    { title: "Tax Optimization", text: "Attractive benefits for non-domicile residents and international investors." }
                                ]
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Ready to invest in Cyprus real estate?"
                        description="Offshore Advisory provides end-to-end support in property acquisition, residency applications, and legal structuring."
                        buttonText="Book a Cyprus Real Estate Investment Consultation Today →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "How much must I invest for Cyprus residency?",
        content: [
            { type: "answer", text: "Minimum €300,000 in new residential property." }
        ],
    },
    {
        question: "Can property investment lead to citizenship?",
        content: [
            { type: "answer", text: "Yes, after 7 years of residence (or 5 if married to a Cypriot)." }
        ],
    },
    {
        question: "Are foreigners allowed freehold ownership?",
        content: [
            { type: "answer", text: "Yes, Cyprus allows freehold property ownership." }
        ],
    },
    {
        question: "Can I rent out my property?",
        content: [
            { type: "answer", text: "Yes, both long-term and short-term rentals are permitted." }
        ],
    },
    {
        question: "How long does residency approval take?",
        content: [
            { type: "answer", text: "Typically 2–4 months for the fast-track process." }
        ],
    },
];
